


import React from "react";
import { GlobalContext } from "../../../../utils/globalprovider.js";



import ToolsBar from "../../../../components/bases/toolsbar/toolsbar.js";
import imglist from "./assets/liste.png"
import imgparams from "./assets/parameters.png"
import "./subtitleerrors.css"
import SubtitleOptions from "./subtitleoptions.js";
import ErrorsList from "./errorslist.js";


class SubtitleErrors extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state = {
          toolsbar:
          { 
            height: 20,


                    items: [
                      {img: imglist ,type:"button", disable:false,fr:"Liste des sous-titres en erreur",en:"Subtitles with errors list", nochangecolor:false, key:{key:"LIST", cat:"shortcut"}},
                      {type:"space"},
                      {img: imgparams ,type:"button", disable:false,fr:"Paramètres",en:"Parameters", nochangecolor:false, key:{key:"PARAMS", cat:"shortcut"}},
                    ],
          },
          displaytab:"LIST",

             
        }
        this.onClickToolsBar = this.onClickToolsBar.bind(this);


    }
    onClickToolsBar(datas)
    {
        switch (datas.cat)
        {
        case "shortcut":
            this.setState({displaytab: datas.key})
            break;
        }
    }
    render()
    {

        var ttitle = "";
        var body = (<></>);
        switch (this.state.displaytab)
        {
            case "LIST":
                ttitle =this.context.language=="fr"?"Liste des sous-titres en erreur":"Subtitles with errors list";

                body =(<ErrorsList 
                    visible = {this.props.visible}
                    stparams = {this.props.stparams}
                    subtitles = {this.props.subtitles}
                    onClick = {this.props.onClick}
                    timecodeasset = {this.props.timecodeasset}
                    current = {this.props.current}

                    />)
                break;
            default:
                ttitle =this.context.language=="fr"?"Paramètres d'affichage des erreurs":"Display error parameters";
                body =(<SubtitleOptions/>)

                break;
        }
        
        return(

            <div className ="errorsfulldiv">
                <div className="errorstitle">
                    {ttitle}
                </div>
                <div className="errorstoolsbar">
                    <ToolsBar 
                    onClick={this.onClickToolsBar} 
                    toolsbar={this.state.toolsbar}
                    currentKey = {this.state.displaytab}
                    />
                </div>
                <div className="errorsbody">
                    {body}
                </div>
            </div>
        )
    }
}
SubtitleErrors.defaultProps = {
        }

export default SubtitleErrors
